import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Calendar18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M6 8C6 8.55228 5.55228 9 5 9C4.44772 9 4 8.55228 4 8C4 7.44772 4.44772 7 5 7C5.55228 7 6 7.44772 6 8Z'
      fill='currentColor'
    />
    <path
      d='M9 9C9.55228 9 10 8.55228 10 8C10 7.44772 9.55228 7 9 7C8.44771 7 8 7.44772 8 8C8 8.55228 8.44771 9 9 9Z'
      fill='currentColor'
    />
    <path
      d='M6 12C6 12.5523 5.55228 13 5 13C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11C5.55228 11 6 11.4477 6 12Z'
      fill='currentColor'
    />
    <path
      d='M9 13C9.55228 13 10 12.5523 10 12C10 11.4477 9.55228 11 9 11C8.44771 11 8 11.4477 8 12C8 12.5523 8.44771 13 9 13Z'
      fill='currentColor'
    />
    <path
      d='M14 8C14 8.55228 13.5523 9 13 9C12.4477 9 12 8.55228 12 8C12 7.44772 12.4477 7 13 7C13.5523 7 14 7.44772 14 8Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.75 2.25H12.25V1H13.75V2.25H16.5C17.1904 2.25 17.75 2.80964 17.75 3.5V15.5C17.75 16.1904 17.1904 16.75 16.5 16.75H1.5C0.809644 16.75 0.25 16.1904 0.25 15.5V3.5C0.25 2.80964 0.809644 2.25 1.5 2.25H4.25V1H5.75V2.25ZM4.25 3.75V5H5.75V3.75H12.25V5H13.75V3.75H16.25V15.25H1.75V3.75H4.25Z'
      fill='currentColor'
    />
  </Svg>
);

Calendar18.displayName = 'Calendar18';
export default Calendar18;
